import React from "react";
import "./AnimatedBackground.css"; 
import { motion } from "framer-motion";// Import the updated custom CSS for the animation
import LandingPageExplore from "./LandingPageExplore";

const AnimatedBackground = ({scrollY}) => {
  return (
    <div className="h-screen w-full flex items-center justify-center animated-gradient">
      <motion.div
        id="offers"
        className="flex w-full flex-col justify-center items-center h-screen "
        initial={{ opacity: 0, y: -100 }}
        animate={{
          opacity: scrollY > 500 ? 1 : 0,
          y: scrollY > 500 ? 0 : -100,
        }}
        transition={{
          delay: 0.8,
          type: 'spring',
          stiffness: 50,
        }}
      >
        
        <motion.h1
          className="lg:text-5xl text-center text-gray-100 mt-10 font-bold sm:text-xl text-2xl anima"
          initial={{ opacity: 0, y: -50 }}
          style={{fontFamily:'Reem Kufi'}}
          animate={{
            opacity: scrollY > 500 ? 1 : scrollY > 200 ? scrollY / 500 : 0,
            y: scrollY > 500 ? 0 : -50,
          }}
          transition={{
            delay: 0.9,
            type: 'spring',
            stiffness: 50,
          }}
        >
          افضل عروضنا
        </motion.h1>  

        <LandingPageExplore scrollY={scrollY} />
      </motion.div>
    </div>
  );
};

export default AnimatedBackground;
